import { render, staticRenderFns } from "./ListPrefactura.vue?vue&type=template&id=8d9b4e00&"
import script from "./ListPrefactura.vue?vue&type=script&lang=js&"
export * from "./ListPrefactura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports